"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromEmbedWidgets = void 0;
var classnames_1 = __importDefault(require("classnames"));
var createHtmlFromEmbedWidgets = function (token) {
    var _a;
    if (!token.embedUrl) {
        return "";
    }
    var style = "";
    if (!!token.width && typeof token.width === "number") {
        style += "width: ".concat(token.width, "%;");
    }
    if (!!token.height) {
        style += "aspect-ratio: 1 / calc(".concat(token.height, " * 0.01)");
    }
    var title = function () {
        switch (token.subType) {
            case "googleMaps":
                return "Google Maps";
            case "video":
                return "Video";
            case "iframe":
                return "Embedded content from external site";
            default:
                return "";
        }
    };
    var c = (0, classnames_1.default)("embed-widget__container", (_a = {
            "embed-widget__container--left-aligned": token.alignment === "left"
        },
        _a["embed-widget__container--".concat(token.width)] = typeof token.width === "string",
        _a));
    return "\n      <figure>\n        <div style=\"".concat(style, "\" class=\"").concat(c, "\">\n          <div class=\"embed-widget__iframe-container\">\n            <iframe\n              src=\"").concat(token.embedUrl, "\"\n              class=\"embed-widget__iframe\"\n              frameborder=\"0\"\n              allowfullscreen\n              title=\"").concat(title(), "\"\n            >\n            </iframe>\n          </div>\n        </div>\n      </figure>\n    ");
};
exports.createHtmlFromEmbedWidgets = createHtmlFromEmbedWidgets;
